module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#magazines",
      toString: function () {
        return this.url;
      }
    }